import {Injectable} from '@angular/core';
import {AbstractMapper} from '../../abstract.mapper';
import {StammdatenTelefonnummer, Telefonnummer} from '@nachdigal';

@Injectable()
export class TelefonnummerMapperService extends AbstractMapper<StammdatenTelefonnummer, Telefonnummer> {

  protected mapInternal(source: StammdatenTelefonnummer): Telefonnummer {
    return {
      vorwahlInternational: source.vorwahlinternational,
      vorwahlNational: source.vorwahlnational,
      rufnummer: source.rufnummer,
      notiz: source.notiz
    };
  }

  protected getMappedArrayDefaultIndex(source: Array<StammdatenTelefonnummer>): number {
    return source.findIndex(value => value.standard);
  }
}
